import type { VillageIncidentDimensionOption } from "../model/villageIncidentCharts";

type ChartDimensionSelectProps = {
  cardId: string;
  chartTitle: string;
  value: string;
  dimensions: VillageIncidentDimensionOption[];
  onChange: (next: string) => void;
};

export function ChartDimensionSelect({ cardId, chartTitle, value, dimensions, onChange }: ChartDimensionSelectProps) {
  return (
    <div className="village-incident-chart-card__controls">
      <label htmlFor={`${cardId}-dimension`} className="small-meta">Group by</label>
      <select
        id={`${cardId}-dimension`}
        className="listing-sort village-incident-chart-card__select"
        aria-label={`Group ${chartTitle} chart by`}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      >
        {dimensions.map((dimension) => (
          <option key={dimension.key} value={dimension.key}>
            {dimension.label}
          </option>
        ))}
      </select>
    </div>
  );
}
